import React from 'react';
import { TooltipRefProps, PlacesType } from 'react-tooltip';
import { TooltipStyle as S } from './Tooltip.style';

type TooltipProps = {
  target?: string;
  title?: string;
  placement?: PlacesType;
  hidden?: boolean;
  className?: string;
};

export const Tooltip = React.forwardRef<TooltipRefProps, TooltipProps>((props, ref) => {
  return (
    <S.Tooltip
      content={props.title}
      place={props.placement}
      anchorSelect={props.target}
      hidden={props.hidden}
      className={props.className}
      delayShow={300}
      delayHide={100}
      positionStrategy="fixed"
      offset={12}
      ref={ref}
      disableStyleInjection
    />
  );
});
